export default __webpack_public_path__ + "static/media/calendarIcon.c689bd71.svg";